<template>
  <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">
    <b-card no-body>
      <b-card bg-variant="light">
        <b-form-row>
          <lg-finder-page-grupo id="finderGrupoProduto" @onselect="selectGrupo" v-model="form.grupoProduto"
            invalidFeedback="Informe um grupo!" :label="'Grupo: *'" :visible="false" :disabled="disabled" class="ml-2"
            :showClear="false">
          </lg-finder-page-grupo>
        </b-form-row>

        <b-form-row>
          <LgFinderPageUnidadeAdministrativa id="finderUnidadeAdministrativaSubgrupoProduto"
            @onselect="selectUnidadeAdministrativa" :prefix="prefix + title + ' > '"
            invalidFeedback="Informe uma unidad administrativa" v-model="form.unidadeAdministrativaResponsavel">
          </LgFinderPageUnidadeAdministrativa>
        </b-form-row>

        <b-form-row>
          <lg-form-input invalidFeedback="Descrição deve ser informada!" description="" :error="$v.form.descricao"
            v-model="form.descricao" label="Descrição: *" lg="12" sm="7" md="10" class="ml-2" />
        </b-form-row>

        <b-form-row>
          <lg-form-input invalidFeedback="Número deve ser informado" description="" :error="$v.form.numero"
            v-model="form.numero" label="Número: *" lg="12" sm="7" md="4" class="ml-2" />
        </b-form-row>

        <b-form-row>
          <lg-form-input invalidFeedback="Prazo de Aquisição(meses) deve ser informado" description=""
            :error="$v.form.prazoAquisicao" v-model="form.prazoAquisicao" label="Prazo de Aquisição(meses): *" lg="12"
            sm="7" md="10" class="ml-2" />
        </b-form-row>

                <b-form-row>
          <lg-form-input invalidFeedback="Intervalo de Aquisição(meses) deve ser informado" description=""
            :error="$v.form.intervaloAquisicao" v-model="form.intervaloAquisicao" label="Intervalo de Aquisição(meses): *" lg="12"
            sm="7" md="10" class="ml-2" />
        </b-form-row>


        <b-form-row>
          <lg-form-const-select :label="'Sujeito a Manutenção Patrimonial:'" v-model="form.manutencao"
            :options="sujeitoManutencaoPatrimonialOptions" size="sm" name="manutencaoPatrimonial-inline"
            class="text-left ml-2" lg="4" sm="2" md="6"></lg-form-const-select>
        </b-form-row>

        <b-form-row>
          <b-form-group label="Status:" class="ml-3">
            <b-form-radio-group v-model="form.situacao" :options="statusOptions" size="sm"
              name="status-inline"></b-form-radio-group>
          </b-form-group>
        </b-form-row>

        <b-form-row>
          <div class="d-flex justify-content-center align-items-center w-100">
            <b-button type="submit" id="salvarCadastro" class=" my-2" size="sm" pill variant="success"
              @click="save">
              <b-icon icon="check-circle" />
              <b-tooltip target="salvarCadastro" title="Salvar"></b-tooltip>

            </b-button>

            <b-button id="cancelarCadastro" class=" my-2 ml-2" size="sm" pill variant="danger" @click="cancelar">
              <b-icon icon="x-circle" />
              <b-tooltip target="cancelarCadastro" title="Cancelar"></b-tooltip>

            </b-button>

          </div>
        </b-form-row>
      </b-card>
    </b-card>
  </b-modal>
</template>

<script>
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import required from "vuelidate/lib/validators/required"
import { FormResourceMixin } from "@/core/mixins/resource"
import ConfirmMixin from "@/core/mixins/confirm"
import LgFinderPageGrupo from "@/components/Finders/LgFinderPageGrupo.vue"
import SubgrupoProdutoService from "@/core/api/SubgrupoProdutoService.js"

export default {
  name: "SubgrupoProdutoForm",
  components: {
    LgFinderPageUnidadeAdministrativa,
    LgFormInput,
    LgFormConstSelect,
    LgFinderPageGrupo,
  },

  mixins: [FormResourceMixin, ConfirmMixin],

  props: {
    id: Number,
    onselect: Function,
    user: Object,
    value: [Number, String],
    prefix: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Unidade Administrativa:",
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    currentGrupo: Object,
    subgrupo: {},
  },

  validations: {
    form: {
      grupoProduto: { required },
      descricao: { required },
      numero: { required },
      prazoAquisicao: { required },
      intervaloAquisicao:{required}
    },
  },

  computed: {
    formIsValid() {
      return !this.$v.$invalid
    },
  },

  data() {
    return {
      showModal: true,
      title: " Cadastro",
      localValue: this.value,
      isBusy: false,
      form: {
        grupoProduto: this.currentGrupo,
        descricao: "",
        numero: null,
        prazoAquisicao: null,
        manutencao: 1,
        intervaloAquisicao:null,
        situacao: 1,
        unidadeAdministrativaResponsavel: {},
      },
      sujeitoManutencaoPatrimonialOptions: [
        { text: "Sim", value: 1 },
        { text: "Não", value: 0 },
      ],
      statusOptions: [
        { text: "Ativo", value: 1 },
        { text: "Inativo", value: 0 },
      ],
    }
  },

  async mounted() {
    this.$subgrupoProdutoService = new SubgrupoProdutoService()
    if (this.subgrupo) {
      this.$subgrupoProdutoService
        .findById(this.subgrupo.id)
        .then(response => {
          this.form = { ...response.data }
        })
        .finally(() => {
          this.isBusy = false
        })
    }
  },
  watch: {
    value(newValue) {
      this.localValue = newValue
    },
  },

  methods: {
    selectUnidadeAdministrativa(unidadeAdministrativa) {
      this.form.unidadeAdministrativaResponsavel = unidadeAdministrativa
    },

    selectGrupo(grupo) {
      this.form.grupoProduto = grupo
    },

    cancelar() {
      this.$emit("close")
    },

    async save() {
      if (!this.formIsValid) {
        this.$v.$touch()
        this.$notify({
          type: "danger",
          message: "Verifique os campos do cadastro.",
        })
        return
      }
      try {
        this.filtro = {};

        if(this.form.unidadeAdministrativa && this.form.unidadeAdministrativa.id){
          this.filtro.unidadeAdministrativa = this.form.unidadeAdministrativa
        }

        this.filtro.grupoProduto = this.form.grupoProduto;
        this.filtro.descricao = this.form.descricao;
        this.filtro.numero = this.form.numero;
        this.filtro.prazoAquisicao = this.form.prazoAquisicao;
        this.filtro.intervaloAquisicao = this.form.intervaloAquisicao;
        this.filtro.manutencao = this.form.manutencao;
        this.filtro.situacao = this.form.situacao;
        this.filtro.id = this.form.id;
        
        await this.$subgrupoProdutoService.save(this.filtro).then(response => {
          if (
            response.status === 200 ||
            response.status === 204 ||
            response.status === 201
          ) {
            this.$notify({
              type: "success",
              message: "Cadastro salvo com sucesso!",
            })
            this.$emit("close")
          } else {
            this.$notify({
              type: "danger",
              message:
                "Ocorreu um erro ao salvar o cadastro. Verifique se já existe um subgrupo com o mesmo número.",
            })
          }
        })
      } catch (e) {
        this.$notify({
          type: "danger",
          message: "Ocorreu um erro ao salvar o cadastro.",
        })
      }
    },
  },
}
</script>
